import { reportCustomEvent } from '@/utils/arms';
import { readArmsFailDetail, truncateArmsFailDetail } from '@/utils/arms/common';

export const ARMS_GUEST_SESSION_EVENT_TYPE = 'guest_session' as const;
export const ARMS_GUEST_SESSION_EVENT_GROUP = 'auth' as const;

const GUEST_SESSION_EVENT_NAME = {
    ATTEMPT: 'guest_session_attempt',
    SUCCESS: 'guest_session_success',
    FAIL: 'guest_session_fail',
} as const;

/** 冷启动游客会话失败原因 */
export type TGuestSessionFailReason =
    /** POST /device/register 失败 */
    | 'device_register_failed'
    /** 游客 POST /auth/login/v1 失败 */
    | 'guest_post_login_failed'
    /** 其它异常（本地存储、网络未分类等） */
    | 'guest_session_unknown';

function sendGuestSessionEvent(name: string, value: number, properties: Record<string, string | number>): void {
    reportCustomEvent(name, ARMS_GUEST_SESSION_EVENT_TYPE, {
        group: ARMS_GUEST_SESSION_EVENT_GROUP,
        value,
        properties: {
            trigger_scene: 'cold_start',
            ...properties,
        },
    });
}

/** 冷启动游客会话开始（注册设备 + 游客登录） */
export function reportGuestSessionAttempt(): void {
    sendGuestSessionEvent(GUEST_SESSION_EVENT_NAME.ATTEMPT, 1, {
        login_method: 'guest',
    });
}

export function reportGuestSessionSuccess(props: {
    user_id: string;
    login_source: number;
    tourist_device_id: string;
}): void {
    sendGuestSessionEvent(GUEST_SESSION_EVENT_NAME.SUCCESS, 1, {
        login_method: 'guest',
        result_status: 'success',
        user_id: props.user_id,
        login_source: props.login_source,
        tourist_device_id: props.tourist_device_id,
    });
}

export function reportGuestSessionFail(props: { fail_reason: TGuestSessionFailReason; fail_detail?: string }): void {
    sendGuestSessionEvent(GUEST_SESSION_EVENT_NAME.FAIL, 0, {
        login_method: 'guest',
        result_status: 'fail',
        fail_reason: props.fail_reason,
        ...(props.fail_detail ? { fail_detail: truncateArmsFailDetail(props.fail_detail) } : {}),
    });
}

/** 未在业务分支上报时，用通用 unknown 兜底 */
export function reportGuestSessionFailFromError(err: unknown): void {
    reportGuestSessionFail({
        fail_reason: 'guest_session_unknown',
        fail_detail: readArmsFailDetail(err),
    });
}
